<script setup>
import { InteractionStatus2Enum } from "@/utils/constants";

const props = defineProps({
  status: { type: String, required: true },
});

const themeByStatus = {
  [InteractionStatus2Enum.TICKET]: "red",
  [InteractionStatus2Enum.ONGOING]: "green",
  [InteractionStatus2Enum.TICKET_ON_HOLD]: "gray",
  [InteractionStatus2Enum.SOFT_ALERT]: "yellow",
  [InteractionStatus2Enum.TICKET_CLOSED]: "green",
};

const theme = themeByStatus[props.status];
</script>

<template>
  <div
    class="status-badge d-flex align-item-center justify-content-center"
    :class="{ [theme]: true }"
  >
    <span class="d-flex align-items-center column-gap-2">
      <IconCircleFill />
      <span
        class="d-flex align-items-center label text-neutral-400 font-size-xs"
        >{{ status }}
      </span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.status-badge {
  max-height: 28px;
  padding: 0.3rem 1rem;
  border-radius: 20px;

  &.red {
    background-color: $red-0;
    border: 1px solid $red-50;

    svg {
      fill: $red-200;
    }
  }

  &.green {
    background-color: $green-0;
    border: 1px solid $green-50;

    svg {
      fill: $green-150;
    }
  }

  &.yellow {
    background-color: $yellow-0;
    border: 1px solid $yellow-50;

    svg {
      fill: $yellow-250;
    }
  }

  &.blue {
    background-color: var(--primary-0);
    border: 1px solid var(--primary-100);

    svg {
      fill: var(--primary-250);
    }
  }

  &.gray {
    background-color: $neutral-50;
    border: 1px solid $neutral-150;

    svg {
      fill: $neutral-250;
    }
  }
}
</style>
